import { PREVIEW_INVENTORY } from './previewInventory'

const CATALOG_TIER_SUFFIX_PATTERN = / \(.*\)$/

// What the preview reads: the built-in sample games, or a Kambi tier through
// the tenant's sportsbook-runtime. The API lists the tiers bound for a tenant.
export const CATALOG_SOURCES = [
  { value: 'sample', label: 'Sample', description: 'Built-in demo games' },
  { value: 'ctn', label: 'CTN', description: 'Kambi CTN test games' },
  { value: 'cts', label: 'CTS', description: 'Kambi CTS test games' },
  { value: 'production', label: 'Production', description: 'The games customers see' },
]

const LIVE_SOURCES = new Set(['ctn', 'cts', 'production'])

export function isLiveSource(source) {
  return LIVE_SOURCES.has(source)
}

export function catalogSourceLabel(source) {
  return CATALOG_SOURCES.find((item) => item.value === source)?.label ?? 'Sample'
}

// Before tiers, the API reported one boolean for the production runtime.
export function liveSourcesFrom(manifests) {
  if (Array.isArray(manifests?.live_sources)) return manifests.live_sources.filter(isLiveSource)
  return manifests?.live_inventory === true ? ['production'] : []
}

export const REGULATIONS = [{ value: 'US-NJ', label: 'New Jersey' }, { value: 'US-PA', label: 'Pennsylvania (blocked)' }]

/** The status bar's one-phrase summary of what the preview reads and simulates. */
export function rehearsalSummary(workspace) {
  const parts = [`${catalogSourceLabel(workspace.catalogSource)} data`]
  if (workspace.jurisdiction !== 'US-NJ') parts.push(REGULATIONS.find((item) => item.value === workspace.jurisdiction)?.label.replace(CATALOG_TIER_SUFFIX_PATTERN, '') ?? workspace.jurisdiction)
  if ((workspace.previewInventory || 'current') !== 'current') parts.push(PREVIEW_INVENTORY.find((item) => item.value === workspace.previewInventory)?.label)
  return parts.join(' · ')
}
